export default {
  JOINORG_GET_REQUEST: "JOINORG_GET_REQUEST",
  JOINORG_GET_RECEIVE: "JOINORG_GET_RECEIVE",
  JOINORG_GET_ERROR: "JOINORG_GET_ERROR",
  INITIALIZED: "INITIALIZED",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED"
};
